import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://pose.quest/api';

export default function MarkaPatent() {
  const [bulletins, setBulletins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    loadBulletins();
  }, []);

  const loadBulletins = async () => {
    try {
      const r = await axios.get(`${API_URL}/marka/bulletins`);
      if (r.data.success) setBulletins(r.data.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;
    try {
      const r = await axios.post(`${API_URL}/marka/search`, { query: searchQuery });
      if (r.data.success) setSearchResults(r.data.data);
    } catch (e) { console.error(e); }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-white">Marka & Patent</h1>
        <span className="text-gray-500 text-sm">turkpatent.gov.tr entegrasyonu</span>
      </div>

      {/* Arama */}
      <div className="bg-gray-900 border border-purple-500/30 rounded-xl p-6">
        <h2 className="text-purple-400 font-bold text-lg mb-4">Marka Araştırma</h2>
        <div className="flex gap-3">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            placeholder="Marka adı veya başvuru no..."
            className="flex-1 bg-black/50 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none"
          />
          <button onClick={handleSearch} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg font-bold transition">
            ARA
          </button>
        </div>
        {searchResults.length > 0 && (
          <div className="mt-4 space-y-2">
            {searchResults.map((r, i) => (
              <div key={i} className="bg-black/30 rounded-lg p-3 text-gray-300 text-sm">
                {JSON.stringify(r)}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Bültenler */}
      <div className="bg-gray-900 border border-blue-500/30 rounded-xl p-6">
        <h2 className="text-blue-400 font-bold text-lg mb-4">Resmi Marka Bültenleri</h2>
        {loading ? (
          <p className="text-gray-500">Yükleniyor...</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {bulletins.map((b, i) => (
              <div key={i} className="bg-black/30 border border-gray-800 rounded-lg p-4 hover:border-blue-500/50 transition">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-white font-bold text-lg">Bülten #{b.title}</h3>
                  <span className="text-xs text-gray-500 bg-gray-800 px-2 py-1 rounded">{b.size_mb} MB</span>
                </div>
                <p className="text-gray-400 text-sm mb-3">{b.description}</p>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-xs">{new Date(b.publish_at).toLocaleDateString('tr-TR')}</span>
                  <a href={b.pdf_url} target="_blank" rel="noreferrer" className="text-blue-400 hover:text-blue-300 text-sm font-medium">
                    PDF İndir →
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
